import { CookiesService } from '~/services';

export const cookiesStore = new CookiesService();
